import { createSelector } from "@reduxjs/toolkit";
import { getBrowserLanguage } from "./userSettingsSlice";
import { UserSettingsState } from "./userSettings.types";
import { isEqual } from "lodash";
import { userSelector } from "./userSelectors";


export const userSettingsSelector = createSelector([
    (state: any) => state.userSettings
], (userSettings: UserSettingsState) => userSettings,
    {
        memoizeOptions: {
            resultEqualityCheck: isEqual,
        },
    });

export const userSettingsInterfaceSelector = createSelector([
    userSettingsSelector
], (userSettings: UserSettingsState) => userSettings.interface);

export const userSettingsInterfacePostListSelector = createSelector([
    userSettingsInterfaceSelector
], (userSettings) => userSettings?.postListv2 || {});

export const userSettingsInterfaceCreationListSelector = createSelector([
    userSettingsInterfaceSelector
], (userSettings) => userSettings?.creationList || {},
    {
        memoizeOptions: {
            resultEqualityCheck: isEqual,
        },
    });

export const userSettingsInterfaceByName = <K extends keyof NonNullable<UserSettingsState["interface"]>>(setting: K) => createSelector(
    [userSettingsInterfaceSelector],
    (interfaceSettings) => interfaceSettings?.[setting]
);

export const userSettingsInterfaceLanguageSelector = createSelector([
    userSelector
], (user) => {
    if (user?.language) return user?.language;
    return getBrowserLanguage();
});
